import 'moment';
import './duration-1387802c.js';
import './unit-e9fb035f.js';
import './timezone-28b65d17.js';
import { N as NumberComparer, S as StringComparer } from './numberComparer-47fa4d1b.js';
import { g as getMostSuitableOrder } from './getMostSuitableOrder-d0da2421.js';

const DICTIONARY_DEFAULT_DISPLAY_SEQUENCE = 1000000000;
class DictionarySorter {
    static custom(orders) {
        return (value1, value2) => getMostSuitableOrder(orders(value1, value2));
    }
}
DictionarySorter.displaySequenceAndCode = {
    descending: (value1, value2) => {
        var _a, _b, _c, _d;
        return getMostSuitableOrder([
            NumberComparer.descending((_a = value1.displaySequence) !== null && _a !== void 0 ? _a : DICTIONARY_DEFAULT_DISPLAY_SEQUENCE, (_b = value2.displaySequence) !== null && _b !== void 0 ? _b : DICTIONARY_DEFAULT_DISPLAY_SEQUENCE),
            StringComparer.descending((_c = value1.code) !== null && _c !== void 0 ? _c : '', (_d = value2.code) !== null && _d !== void 0 ? _d : ''),
        ]);
    },
    ascending: (value1, value2) => {
        var _a, _b, _c, _d;
        return getMostSuitableOrder([
            NumberComparer.ascending((_a = value1.displaySequence) !== null && _a !== void 0 ? _a : DICTIONARY_DEFAULT_DISPLAY_SEQUENCE, (_b = value2.displaySequence) !== null && _b !== void 0 ? _b : DICTIONARY_DEFAULT_DISPLAY_SEQUENCE),
            StringComparer.ascending((_c = value1.code) !== null && _c !== void 0 ? _c : '', (_d = value2.code) !== null && _d !== void 0 ? _d : ''),
        ]);
    },
};

export { DictionarySorter as D, DICTIONARY_DEFAULT_DISPLAY_SEQUENCE as a };
//# sourceMappingURL=dictionarySorter-1f1c5424.js.map
